/* eslint-disable prettier/prettier */
import { api } from './axios';

export const CompanyService = {
  createCompany: async (formData: FormData) => {
    return api.post('/companies', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  getCompanies: async () => {
    return api.get('/companies/with-users');
  },

  getProgramDefinition() {
    return api.get('/companies/program-definition');
  },
  updateProgramDefinition(data: { fields: string[] }) {
    return api.patch('/companies/program-definition', data);
  },

  uploadExcel: (type: 'cedants' | 'brokers', data: FormData) =>
    api.post(`/companies/excel/upload?type=${type.toUpperCase()}`, data),

  deleteExcel: (type: 'cedants' | 'brokers') => {
    const upperType = type.toUpperCase(); 
    return api.delete(`/companies/excel/delete?type=${upperType}`);
  },

  getCompany: () => api.get(`/companies/me`),

  async checkDuplicateCompanyName(name: string): Promise<boolean> {
    const res = await api.get('/companies/check-name', { params: { name } });
    return res.data.exists;
  },

  getCountries: async () => {
    return api.get('/country');
  },

  updateCompany: async (id: string, formData: FormData) => {
    return api.patch(`/companies/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  toggleStatus: async (id: string) => {
    return api.patch(`/companies/${id}/toggle-status`);
  },

  fetchExcelFile: async (type: 'cedants' | 'brokers') => {
  const response = await api.get(`/companies/excel/${type}/stream`, {
    responseType: 'arraybuffer',
  });
  return response.data;
},

};
